<template>
  <div>
    <Row :gutter="8" class="m-b-10">
      <i-col span="3">
        <Select size="small" placeholder="选择状态" clearable transfer v-model="query.accountStatus"
          @on-change="onChangeStatus">
          <i-option v-for="item in statusArray" :key="'status_' + item.key" :value="item.key">
            {{ item.value }}
          </i-option>
        </Select>
      </i-col>
      <i-col span="3">
        <DatePicker transfer size="small" class="text-black" v-model="actionDateRange" format="yyyy-MM-dd"
          type="daterange" style="width: 100%;" placeholder="选择作业日期" @on-change="onChangeActionDate"></DatePicker>
      </i-col>
      <i-col span="3">
        <Select size="small" v-model="query.assetId" :clearable="true" transfer placeholder="选择资产"
          @on-change="onChangeAsset">
          <Option v-for="item in companyAssetArray" :key="'asset_' + item.id" :value="item.id">{{ item.name }}</Option>
        </Select>
      </i-col>
      <i-col span="3">
        <Select size="small" v-model="query.stationId" :clearable="true" transfer placeholder="选择站点">
          <Option v-for="item in stationArray" :key="'station_' + item.id" :value="item.id">{{ item.name }}</Option>
        </Select>
      </i-col>
      <i-col span="3">
        <Select size="small" v-model="query.taskitemType" :clearable="true" transfer placeholder="选择任务类型"
          @on-change="onChangeTaskType">
          <Option v-for="item in taskitemTypeArray" :key="'type_' + item.value" :value="item.value">{{ item.name }}
          </Option>
        </Select>
      </i-col>
      <i-col span="3">
        <Select size="small" v-model="query.adType" :clearable="true" transfer placeholder="选择用途">
          <Option v-for="item in adTypeArray" :key="'adType_' + item.value" :value="item.value">{{ item.name }}</Option>
        </Select>
      </i-col>
      <i-col span="4">
        <i-input v-model="query.keyword" size="small" placeholder="关键字：资源编号、客户名称"></i-input>
      </i-col>
      <i-col span="2">
        <Button type="primary" icon="ios-search" size="small" @click="onSearch">搜索</Button>
      </i-col>
    </Row>
    <Row :gutter="8" class="m-b-10">
      <i-col span="18">
        <Button size="small" type="success" class="m-r-5" :disabled="btnConfirm" @click="onConfirmRecon">确认对账</Button>
        <Button size="small" type="primary" class="m-r-5" @click="onDownloadTask">下载工单明细</Button>
      </i-col>
      <i-col span="6" class="text-right text-14">
        <span>总计金额：</span><strong class="text-green p-r-10">￥ {{ totalAmount }}</strong>
      </i-col>
    </Row>
    <div>
      <Table stripe max-height="620" size="small" :data="tableList" :columns="tableColumns" :loading="tableLoading"
        @on-selection-change="onSelectionTable"></Table>
      <Row :gutter="8">
        <i-col span="6">
          <div class="m-t-5" style="line-height:25px;">当前已选中<span style="color:#ff9900;padding:0 3px">{{
            selectedItem.length }}</span>条</div>
        </i-col>
        <i-col span="18">
          <div class="paging_style">
            <Page size="small" :total="total" :page-size="query.pageSize" show-total show-elevator show-sizer
              :page-size-opts="pagesizeSetting" @on-page-size-change='onChangePageSize' :current="query.pageNumber"
              @on-change="onChangePageNum"></Page>
          </div>
        </i-col>
      </Row>
    </div>
    <task-detail ref="taskDetail" :checkType="curListTab" />
    <adjustment-cost ref="adjustmentCost" @updateTable="getTableData" />
    <download-task ref="downloadTask" :taskitemTypeArray="taskitemTypeArray" />
  </div>
</template>

<script>
import { indexMixins } from '../../mixins'
import { getAccountTaskitemPage, getTaskitemAccountStatistic } from '@/api/msp/plan'
import { startAccount } from '@/api/msp/taskitem'

// compontes
import TaskDetail from '../common/TaskDetail.vue'
import AdjustmentCost from './AdjustmentCost.vue'
import DownloadTask from '../common/DownloadTask.vue'
export default {
  mixins: [indexMixins],
  components: { TaskDetail, AdjustmentCost, DownloadTask },
  data () {
    return {
      statusArray: [
        { key: 1, value: '未对账' },
        { key: 2, value: '已对账' }
      ],
      query: {
        pageNumber: 1,
        pageSize: 15,
        accountStatus: 1,
        startActionDate: '',
        endActionDate: '',
        assetId: undefined,
        stationId: undefined,
        taskitemType: undefined,
        adType: undefined,
        keyword: ''
      },
      tableLoading: false,
      tableList: [],
      total: 0,
      tableColumns: [],
      totalAmount: 0
    }
  },
  created () {
    this.initData()
  },
  computed: {
    btnConfirm () {
      return !this.selectedItem.length
    }
  },
  methods: {
    /**
     * 初始化
     */
    initData () {
      this.curListTab = 2
      this.generateColumns()
      this.getCompanyAssetArray()
      this.getTaskitemTypeData()
      this.getTableData()
      this.getStatisticData()
    },
    /**
     * 动态生成列表
     */
    generateColumns () {
      const columns = ['selection', 'code', 'position', 'typeName', 'actionDate', 'adTypeName', 'customer', 'schedule', 'feeName', 'chargeUnitCost', 'chargeQuantity', 'chargeTotalFee', 'reconTime', 'checkUser', 'chargeStatus', 'remark', 'operate']
      const showColumns = []
      columns.forEach(col => showColumns.push(this.defineColumns[col]))
      this.tableColumns = showColumns
    },
    /**
     * 获取列表数据
     */
    async getTableData () {
      this.tableLoading = true
      const result = await getAccountTaskitemPage(this.query).finally(() => { this.tableLoading = false })

      if (result && !result.errcode) {
        this.tableList = result.list
        this.total = result.totalRow
        this.tableList.forEach(item => {
          item._disabled = item.qualityTesting
          item._checked = this.selectedItem.some(x => x === item.id)
        })
      } else {
        this.tableList = []
        this.total = 0
      }
    },
    onChangeStatus () {
      this.query.pageNumber = 1
      this.selectedItem = []
      this.getTableData()
      this.getStatisticData()
    },
    onSearch () {
      this.query.pageNumber = 1
      this.selectedItem = []
      this.getTableData()
      this.getStatisticData()
    },
    onChangePageSize (pageSize) {
      this.query.pageSize = pageSize
      this.query.pageNumber = 1
      this.getTableData()
    },
    onChangePageNum (page) {
      this.query.pageNumber = page
      this.selectedItem = []
      this.getTableData()
    },
    getStatisticData () {
      getTaskitemAccountStatistic(this.query).then(res => {
        this.totalAmount = (res && !res.errcode) ? res : 0
      })
    },
    onConfirmRecon () {
      this.$Modal.confirm({
        title: '操作提示',
        content: '确认信息无误，并完成对账？',
        onOk: () => {
          const postData = {
            taskitemChargeIds: JSON.stringify(this.selectedItem)
          }
          startAccount(postData).then(res => {
            if (res && res.errcode === 0) {
              this.$Notice.success({ desc: '操作成功' })
              this.selectedItem = []
              this.getTableData()
            }
          })
        }
      })
    },
    onAdjustCost (params) {
      this.$nextTick(() => {
        this.$refs.adjustmentCost.showModal(params)
      })
    }
  }
}
</script>
